module.exports = __webpack_public_path__ + "static/media/whitecross.94d03d3e.svg";